<template>
    <div class="app">
        <Navigation />

        <main v-if="!user">
            <login>
                <template v-slot:title>My gear</template>
                <template v-slot:text>Login to save your gear.</template>
            </login>
        </main>

        <main v-if="user">

            <div class="app__title">
                <h1>My gear</h1>

                <button @click="addGearModal()" v-b-tooltip.hover title="Add gear" class="button button--icon">
                    <i class="las la-plus"></i>
                </button>
            </div>

            <div v-if="user.gear && user.gear.length" class="gear__overview">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-3 col-md-4 col-12 m-b-1" v-for="g in user.gear" :key="g.id">
                            <ListItemGear :gearId="g.gearId">
                                <button class="button button--ghost button--icon" v-b-tooltip.hover title="Remove from my gear" @click="deleteGear(g.gearId)">
                                    <i class="las la-trash-alt"></i>
                                </button>
                            </ListItemGear>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="empty-message">
                <span>🎸</span>
                <h2>Start adding gear</h2>
                <p>Looks like you don't have any gear in your collection... yet. This is a nice place to keep track of your pedals, amps and cabinets.</p>
                <button class="button button--green" @click="addGearModal()">Add my first</button>
            </div>

            <div class="overlay" v-if="showAddGearModal">
                <div class="overlay__holder">
                    <div class="overlay__title">
                        <strong>Add gear</strong>
                        <div class="overlay__close" @click="showAddGearModal = false">&times;</div>
                    </div>

                    <div class="overlay__content">
                        <input type="search" placeholder="Search your gear" v-model="query" />

                        <div class="search__suggestions" v-if="searchResults.length > 0">
                            <div class="gear__select" @click="addMyGear(item.id)" v-for="item in searchResults" :key="item.id">
                                <div class="gear__select__image">
                                    <GearImage :gearId="item.id" />
                                </div>
                                <GearTitle :gearId="item.id" />
                            </div>
                        </div>
                    </div>

                    <div v-if="searchResults.length === 0 && query.length > 0" class="overlay__footer">
                        <p>Couldn't find <strong>{{ query }}</strong>...</p>
                        <button @click="addNewGearModal()" class="button">Add new gear</button>
                    </div>

                </div>
            </div>

            <ModalAddGear v-if="showAddNewGearModal" @close="showAddNewGearModal = false" />
        </main>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Navigation from "@/components/Nav";
import ListItemGear from "@/components/ListItemGear.vue";
import ModalAddGear from "@/components/ModalAddGear";
import Login from '@/components/Login.vue';
import GearImage from './GearImage.vue';
import GearTitle from './GearTitle.vue';

export default {
    data() {
        return {
            query: '',
            showAddGearModal: false,
            showAddNewGearModal: false,
        };
    },
    computed: {
        ...mapState(['gear', 'user']),
        searchResults() {
            var results = []
            if(this.query) {
                results = this.gear.filter(item => {
                    var term = (item.brand+" "+item.title).toLowerCase()
                    return term.search(this.query.toLowerCase()) > -1
                })
                
                if(this.user.gear) {
                    results = results.filter(item => {
                        return !this.user.gear.find(gear => item.id === gear.gearId)
                    })
                }
            }
            return results
        }
    },
    components: { ModalAddGear, Navigation, ListItemGear, Login, GearImage, GearTitle },
    methods: {
        addGearModal: function() {
            this.showAddGearModal = true;
        },

        deleteGear: function(gearId) {
            this.$store.dispatch('deleteGearUser', gearId)
        },

        addNewGearModal: function() {
            this.showAddNewGearModal = true;
        },

        addMyGear: function(gearId) {
            this.$store.dispatch('addGearUser', gearId)
            this.query = ''
        }
    },
    created() {
    },
    destroyed() {
    },
}
</script>